<template>
  <div class="guide-wrap" v-if="show">
    <div class="kx-container guide-content-wrap" id="guideBox">

      <div class="guide-step"
        v-if="step === 0"
        style="
          width: 1032px;
          position: absolute;
          right: 80px;
          top: 145px;">
        <img src="../assets/guide/1-2.png" />
        <div class="guide-btn" 
          style="right:252px; bottom: 26px;"
          @click="skip()"></div>
        <div class="guide-btn the-btn-next"
          style="right:0px; bottom: 22px;"
          @click="next(1)"></div>
      </div>

      <div class="guide-step"
        v-if="step === 1"
        style="
        margin-top: 162px;
        width: 1090px;
        margin-left: 80px;">
        <img src="../assets/guide/2.png" />
        <div class="guide-btn the-btn-next" 
          style="top:-6px;right: 63px; "
          @click="next('2-a1')"></div>
        <div class="guide-btn"
          style="top:-9px;right: 291px;"
          @click="skip()"></div>
      </div>

      <div class="guide-step"
        v-if="step === '2-a1'"
        style="
          margin-top: 305px;
          width: 710px;">
        <img src="../assets/guide/2-a1.png" />
        <div class="guide-btn" 
          style="right: 228px;bottom: 84px;height: 82px;"
          @click="skip()"></div>
        <div class="guide-btn the-btn-next"
          style="right: 0px;bottom:84px;height: 82px;width: 190px;"
          @click="next(2)"></div>
      </div>

      <div class="guide-step"
        v-if="step === 2"
        style="
          margin-top: 371px;
          width: 1218px;">
        <img src="../assets/guide/2-1.png" />
        <div class="guide-btn" 
          style="right: 423px;bottom: 11px;"
          @click="skip()"></div>
        <div class="guide-btn the-btn-next"
          style="right: 131px;bottom: 0px;height: 107px;width: 230px;"
          @click="next(3)"></div>
      </div>

      

      <div class="guide-step"
        v-if="step === 3"
        style="
        margin-top: 233px;
        width: 1090px;
        margin-left: 79px;">
        <img src="../assets/guide/4.png" />
        <div class="guide-btn the-btn-next" 
          style="top:-6px;right:109px; width:175px; "
          @click="next(4)"></div>
        <div class="guide-btn"
          style="top:-9px;right: 321px;"
          @click="skip() "></div>
      </div>

      <div class="guide-step"
        v-if="step === 4"
        style="width: 558px;
          position: absolute;
          right: 2px;
          top: 287px;
        ">
        <img src="../assets/guide/3.png" />
        <div class="guide-btn" 
          style="right:389px; bottom: 6px;"
          @click="skip()"></div>
        <div class="guide-btn the-btn-next"
          style="right:109px; bottom: 0px;"
          @click="next(5)"></div>
      </div>

      <div class="guide-step"
        v-if="step === 5"
        style="
        position: absolute;
        top: 200px;
        width: 1090px;">
        <img src="../assets/guide/5.png" />
        <div class="guide-btn the-btn-next" 
          style="top: -1px;right: 35px;"
          @click="next(6)"></div>
        <div class="guide-btn"
          style="top:-4px;right:286px;"
          @click="skip() "></div>
      </div>

      <div class="guide-step"
        v-if="step === 6"
        style="position:fixed;
          right: -5px;
          top: 406px;
          width: 700px;">
        <img src="../assets/guide/6-1.png" />
        <div class="guide-btn the-btn-next" 
          style="top:5px;left:186px;"
          @click="next(7)"></div>
        <div class="guide-btn"
          style="top:5px;left:15px;"
          @click="skip() "></div>
      </div>

      <div class="guide-step"
        v-if="step === 7"
        style=" position: absolute;
          width: 508px;
          top: 12px;
          left: 104px;">
        <img src="../assets/guide/7.png" />
        <div class="guide-btn the-btn-next" 
          style="bottom: -1px;right: 153px;"
          @click="goToCourse()"></div>
      </div>

    </div>
  </div>
</template>

<script>
/**
 * 1.输入Profile
 * 2.展示查询结果
 * 提示有多站点选择
 * 3.输入黑名单账号
 * 4.展示黑名单查询结果
 * 5.举报恶意账号
 * 6.显示举报恶意账号页面
 * 7.联系客服经理
 * 8.使用教程
 * 黑名单查询
 */
export default {
  name: 'guide', // 引导图
  components: {},
  props: {},
  data() {
    return {
      show: true,
      step: 0,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        // document.body.offsetHeight
        document.querySelector('#guideBox')
      })
    })
  },
  methods: {
    // 下一步
    next(step) {
      // console.log('step', step)
      this.step = step
    },
    // 跳过
    skip() {
      this.show = false
    },
    goToCourse(){
      this.$router.push({
        path: '/course-page',
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .guide-wrap {
    width: 100%;
    height: 100%;
    position: absolute; // fixed
    top: 0;
    right: 0;
    z-index: 2000;
    background: rgba(0,0,0, .6);
    .guide-step {
      position: absolute; 
    }
    .guide-btn {
      width: 116px;
      height: 90px;
      /* border: 1px solid blue; */
       /* background: blue; */
      cursor: pointer;
      position: absolute;
      &.the-btn-next {
        width: 205px;
        height: 90px;
        /* border: 1px solid red; */
        /* background: red; */
      }
    }
    .guide-content-wrap {
      position: relative;
      min-height: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
